import {
  CheckoutSessionResponse,
  OrderGroupResponse,
  OrderLineResponse,
  OrderResponse,
  PickupTicketResponse,
  ShippingRateResponse
} from './order.response';
import {
  CheckoutSessionState,
  OrderGroupState,
  OrderLineState,
  OrderState,
  PickupTicketState,
  ShippingRateState
} from './order.state';

/** Pure wire → state mappers for the checkout and order endpoints. */

export function mapCheckoutSessionResponse(response: CheckoutSessionResponse): CheckoutSessionState {
  return {
    ...response,
    reservationExpiresAt: new Date(response.reservationExpiresAt),
    conflictListingIds: [...response.conflictListingIds]
  };
}

export function mapShippingRateResponse(response: ShippingRateResponse): ShippingRateState {
  return { ...response };
}

export function mapOrderLineResponse(response: OrderLineResponse): OrderLineState {
  return { ...response };
}

export function mapPickupTicketResponse(response: PickupTicketResponse): PickupTicketState {
  return {
    ...response,
    stagedAt: response.stagedAt ? new Date(response.stagedAt) : null,
    expiresAt: new Date(response.expiresAt)
  };
}

export function mapOrderGroupResponse(response: OrderGroupResponse): OrderGroupState {
  return {
    ...response,
    lines: response.lines.map(mapOrderLineResponse),
    pickupTicket: response.pickupTicket ? mapPickupTicketResponse(response.pickupTicket) : null,
    refund: response.refund ? { ...response.refund, refundedAt: new Date(response.refund.refundedAt) } : null
  };
}

export function mapOrderResponse(response: OrderResponse): OrderState {
  return {
    ...response,
    placedAt: new Date(response.placedAt),
    totals: { ...response.totals },
    groups: response.groups.map(mapOrderGroupResponse)
  };
}
